<nav #navBar class="navbar navbar-light navbar-expand-sm pt-0 pb-0 mb-1 border-top border-dark"
    (scroll)="onScroll()" [ngClass]="{ 'position-sticky top-0 w-100' : isStickyActive }"
    style="background-color: #e0e0e0">
  <!-- Links -->
  <ul class="navbar-nav">
    <li *ngFor="let navItem of navItems; index as i">
      <a
        class="nav-link"
        *ngIf="
          (navItem.if || isUndefined(navItem.if)) &&
          isUndefined(navItem.routerLink) && isUndefined(navItem.scrollTo)
        "
        [attr.data-test-selector]="navItem.text + '-anchor'"
        [href]="navItem.link"
        [ngClass]="{
          active: navItem.activePage === activePage,
          disabled: navItem.disable
        }"
      >
        {{ navItem.text }}
      </a>
      <a class="nav-link nav-scroll"
         *ngIf="(navItem.if || isUndefined(navItem.if)) && !isUndefined(navItem.scrollTo)"
         [attr.data-test-selector]="navItem.text + '-anchor'"
         (click)="scrollToElement(navItem.scrollTo || '', i)"
         [routerLink]="[]"
         [ngClass]="{
           active: (i == activeItem && !scrolledTo) || i == scrolledTo,
           disabled: navItem.disable
         }">
        {{ navItem.text }}
      </a>
      <a class="nav-link"
         *ngIf="(navItem.if || isUndefined(navItem.if)) && !isUndefined(navItem.routerLink)"
         [attr.data-test-selector]="navItem.text + '-anchor'"
         [routerLink]="navItem.routerLink"
         [queryParams]="navItem.queryParams"
         [ngClass]="{
           active: navItem.activePage === activePage,
           disabled: navItem.disable
         }">
        {{ navItem.text }}
      </a>
    </li>
  </ul>
  <div *ngIf="partnerName!==''" class="navbar-collapse padding-right-20-px partner-name">
    {{partnerName}}
  </div>
  <!-- Buttons -->
  <div class="navbar-collapse padding-right-20-px">
    <ul class="nav navbar-nav ms-auto">
      <li class="nav-item" *ngFor="let navButton of navButtons">
        <app-button
          [options]="navButton"
          *ngIf="isActivePage(navButton.activePages) && (navButton.if || isUndefined(navButton.if))">
        </app-button>
      </li>
    </ul>
  </div>
</nav>


